export const ROUTE_CHANGED = 'ROUTE_CHANGED';
